export default "__VITE_ASSET__CWIJGBdV__"